import { Palette, MessageSquare, Briefcase, UserCheck } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

const PersonaCards = () => {
  const personas = [
    {
      icon: Palette,
      title: "Freelance designers & developers",
      description: "Keep client work, timelines, invoices, and priorities in one place — without dropping follow-ups or undercharging."
    },
    {
      icon: MessageSquare,
      title: "Consultants & coaches",
      description: "Turn calls and sessions into tasks, invoices, and next steps automatically, so nothing important gets lost after the meeting."
    },
    {
      icon: Briefcase,
      title: "Solo agencies & indie studios",
      description: "See your pipeline, client revenue, and delivery workload together so you can scale without burning out."
    },
    {
      icon: UserCheck,
      title: "Any independent worker",
      description: "If your income depends on clients and projects, Catlyo becomes your operating system for running the business side of your work."
    }
  ];

  return (
    <section className="py-20 bg-background">
      <div className="container max-w-7xl mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold">
            Perfect for serious solo professionals.
          </h2>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {personas.map((persona, index) => {
            const Icon = persona.icon;
            return (
              <Card key={index} className="border-border/50 hover:border-primary/50 transition-colors">
                <CardHeader>
                  <div className="h-12 w-12 rounded-lg bg-primary/10 flex items-center justify-center mb-4">
                    <Icon className="h-6 w-6 text-primary" />
                  </div>
                  <CardTitle className="text-lg leading-tight">{persona.title}</CardTitle>
                </CardHeader>
                <CardContent>
                  <p className="text-sm text-muted-foreground leading-relaxed">
                    {persona.description}
                  </p>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default PersonaCards;
